import { NgIf, NgStyle, NgTemplateOutlet } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { NzIconModule } from 'ng-zorro-antd/icon';
import { UIRippleDirective } from '../ripple';

@Component({
  selector: 'ui-icon',
  templateUrl: './icon.component.html',
  styleUrl: './icon.component.scss',
  standalone: true,
  imports: [NgIf, NgStyle, NgTemplateOutlet, NzIconModule, UIRippleDirective],
})
export class UIIcon {
  @Input() size = '24px'; // Default size
  @Input() name?: string;
  @Input() color?: string;
  @Input() filled?: boolean;
  @Input() clickable?: boolean;
  @Input() isSpining?: boolean;

  @Output() clicked = new EventEmitter<Event>();

  get iconTheme() {
    return this.filled ? 'fill' : 'outline';
  }

  onClicked(event: Event): void {
    this.clicked.emit(event);
  }
}
